import { UserType } from '../interfaces/userType.enum';

/** SupplierController read endpoints: @PreAuthorize("hasAnyRole('StoreAdmin', 'InstitutionAdmin', 'Accountant')"). */
export const SUPPLIER_READ_ROLES: UserType[] = [UserType.StoreAdmin, UserType.InstitutionAdmin, UserType.Accountant];
